// extracted by mini-css-extract-plugin
export default {"wrapper":"Select_wrapper__g9GNt","item":"Select_item__Kebdh","errorMessage":"Select_errorMessage__MvhjP"};